import styled from "styled-components";
import { Title as BaseTitle } from "./customize-modal-kit";

export const Title = styled(BaseTitle)`
  color: ${({ theme }) => theme.styleGuide.colors.helix['brand']};
`;
